import { render, staticRenderFns } from "./DataListIntra.vue?vue&type=template&id=11af0f46&scoped=true"
import script from "./DataListIntra.vue?vue&type=script&lang=js"
export * from "./DataListIntra.vue?vue&type=script&lang=js"
import style0 from "./DataListIntra.vue?vue&type=style&index=0&id=11af0f46&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11af0f46",
  null
  
)

export default component.exports